const getEmailAPIPostSchema = (countryCode, businessCode, locale) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        emailDetails:
        {
            toList: [],
            bccList: [],
            recipientName: "Sales App",
            locale: locale,
            isGenericApprovalNotification: true
        },
    };
};



export {
    getEmailAPIPostSchema
};
